<template>
  <div>
    <ConsolidationMeestHead
        :showFilter="showFilter"
        :countFilterParams="countFilterParams"
        :navTabs="navTabs"
        @changeTab="(data) => $emit('changeTab', data)"
        @toggleFilter="toggleFilter"
        @filter="$emit('filter')"
        @sentConsolidationMeest="$emit('sentConsolidationMeest')"
        @changeFilter="changeFilter"
        @selectAll="selectAll"
    />

    <div class="table-filter-wrap">

      <ConsolidationMeestFilter
          :showFilter="showFilter"
          :filterGetParams="filterGetParams"
          :countFilterParams="countFilterParams"
          @close="closeFilter"
          @changeFilter="changeFilter"
          @resetFilter="$emit('resetFilter')"
      />

      <ConsolidationMeestTable
          :countFilterParams="countFilterParams"
          :selectedNow="selectedNow"
          :navTabs="navTabs"
          @showMore="$emit('showMore')"
          @resetFilter="$emit('resetFilter')"
      />
    </div>
  </div>
</template>

<script>


  import ConsolidationMeestHead from "./ConsolidationMeestHead/ConsolidationMeestHead";
  import ConsolidationMeestTable from "./ConsolidationMeestTable/ConsolidationMeestTable";
  import ConsolidationMeestFilter from "./ConsolidationMeestFilter/ConsolidationMeestFilter";

  export default {
    name: "ConsolidationMeestTableUser",

    components: {
      ConsolidationMeestHead,
      ConsolidationMeestTable,
      ConsolidationMeestFilter,
    },

    props: {
      countFilterParams: Number,
      navTabs: Object,
      filterGetParams: Object,
    },

    data(){
      return{
        showFilter: false,
        filterId: '',
        filterName: '',

        selectedNow: false,
      }
    },

    methods: {
      closeFilter() {
        this.showFilter = false
      },

      toggleFilter() {
        this.showFilter = !this.showFilter
      },

      changeShopType(index) {
        this.$emit('changeShopType', index)
      },


      changeFilter(data) {
        console.log(data);
        this.$emit('changeFilter', data)
      },

      selectAll(val) {
        this.selectedNow = val
      },
    }
  }
</script>

<style scoped>

</style>
